import moment from "jalali-moment";
import { v4 as uuidv4 } from "uuid";
export const CostRender = new Intl.NumberFormat("en-US");

export const timeSince = date => {
  if (date) {
    let data = new Date(date);

    let seconds = Math.floor((new Date() - data) / 1000);

    let interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " سال پیش";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " ماه پیش";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " روز پیش";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " ساعت پیش";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " دقیقه پیش";
    }
    return "اخیرا";
  } else {
    return "none";
  }
};
export const cutText = (txt, length = 20) => {
  if (txt) {
    return `${txt.slice(0, length)} ...`;
  }
};
export const humanFileSize = (bytes, si = false, dp = 1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};
export const ToDateJalali = date => {
  if (date) {
    return moment(date).locale("fa").format("YYYY/MM/DD");
  } else {
    return null;
  }
};
const renderDay = day => {
  if (day) {
    if (day.split("")[0] == "0") {
      return day.split("")[1];
    } else {
      return day;
    }
  }
};

export const renderTimeMonth = date => {
  if (date) {
    let jalali = ToDateJalali(date).split("/");
    return `${renderDay(jalali[2])} ${renderMonth(jalali[1])}`;
  }
};
export const renderMonth = data => {
  switch (data) {
    case "01":
    case 1:
      return "فروردین";
    case "02":
    case 2:
      return "اردیبهشت";
    case "03":
    case 3:
      return "خرداد";
    case "04":
    case 4:
      return "تیر";
    case "05":
    case 5:
      return "مرداد";
    case "06":
    case 6:
      return "شهریور";
    case "07":
    case 7:
      return "مهر";
    case "08":
    case 8:
      return "آبان";
    case "09":
    case 9:
      return "آذر";
    case "10":
    case 10:
      return "دی";
    case "11":
    case 11:
      return "بهمن";
    case "12":
    case 12:
      return "اسفند";
    default:
      return "نامشخص";
  }
};
export const now = () => {
  const m = moment();
  m.locale("fa");
  return `${m.format("dddd")}، 
  ${m.format("DD")}
  / ${m.format("MMM")} ماه /
  ${m.format("YYYY")}`;
};
export const p2e = s => s.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
export const addMinutes = (numOfMinutes, date = new Date()) => {
  date.setMinutes(date.getMinutes() + numOfMinutes);
  return date;
};
export const renderPrice = price => {
  if (price == 0 || price == "0") {
    return `به صورت توافقی`;
  }
  if (price) {
    return `${CostRender.format(price)} ${"تومان"} `;
  }
  return false;
};
export const ConvertDate = date => {
  if (date) {
    return moment.from(date, "fa", "YYYY/MM/DD").format("YYYY/MM/DD");
  } else {
    return null;
  }
};
export const ToTimeJalali = date => {
  if (date) {
    return moment(date).locale("fa").format(" HH:mm:ss - YYYY/MM/DD");
  } else {
    return null;
  }
};
